<template>
  <div id="studentMock">
    <template v-if="$route.name === 'studentMock'">
      <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>

      <ots-table-group-new
        v-loading="loading"
        :selectList="selectList"
        :requestForm="requestForm"
        :tableHeader="tableHeader"
        :tableOption="tableOption"
        :tableData="tableData"
        :pagination="pagination"
        @search="search"
      ></ots-table-group-new>

      <!-- 短信督导弹窗 -->
      <ots-custom-dialog
        :dialog.sync="sendDialog"
        title="短信督导"
        width="40%"
      >
        <template v-slot:content>
          <div class="export-setting" v-loading="groupLoading">
            <ul>
              <li>本次将为<span class="col_red">{{tmpGroupCount.shouldSendCount}}</span>位学生发送督导</li>
              <li>实际可发送<span class="col_red">{{tmpGroupCount.actualSendCount}}</span>条</li>
              <li>只能发送短信督导<span class="col_red">{{tmpGroupCount.onlySendSmsCount}}</span>条</li>
              <li>只能发送邮件督导<span class="col_red">{{tmpGroupCount.onlySendEmailCount}}</span>条</li>
              <li>可同时发送<span class="col_red">{{tmpGroupCount.bothSendCount}}</span>条</li>
            </ul>
            <div class="mt10">
              <el-input type="textarea" v-model="content" :rows="4"/>
            </div>
            <div class="mt20 col_grayQ">
              <p>提示：</p>
              <p class="mt10"> 1、<span class="col_red mr5">{学生姓名}</span>系统动态获取学生的姓名显示！不需要可删除。</p>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="sendDialog = false">取消</el-button>
          <el-button round type="primary" @click="messagePushFn">确定</el-button>
        </template>
      </ots-custom-dialog>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>


<script>
import {
  studentMockGetCourseMockListApi,
  getPlanListApi,
  studentMockGetMessageSendGroupCountApi,
  studentMockSendMessageApi
} from "@/http/modules/applySet/studentMock.js";

export default {
  name: "StudentMock",
  data() {
    return {
      loading: false,
      mainTopBtnList: [
        { title: "短信督导", fn: this.openMessageDialog }
      ],
      requestForm: {
        planId: "",
        courseIds: ""
      },
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: []
        },
        {
          title: "考试课程",
          type: "select",
          requestKey: "courseIds",
          label: "courseName",
          value: "courseId",
          data: [{ courseName: "全部", courseId: "" }]
        }
      ],
      tableHeader: [
        { title: "考试批次", prop: "planName" },
        { title: "考试课程", prop: "courseName", width: 200 },
        { title: "模考名称", prop: "mockName", width: 200, align: "center"},
        { title: "模考试卷名称", prop: "paperName", width: 200 },
        {
          title: "模考起止时间",
          width: 200,
          formatter: scope => {
            if (!scope.row.beginTime) return "-";
            return `${this.formatTime(scope.row.beginTime)} <br>~<br> ${this.formatTime(scope.row.endTime)}`;
          }
        },
        { title: "应模考人数", prop: "shouldMock", width: 150, align: "center" },
        {
          title: "已参加模考人数",
          type: "button",
          prop: "hasMock",
          width: 150,
          align: "center",
          formatter: scope => String(scope.row.hasMock || 0),
          click: row => this.goStudentList(row, "1"),
          disableFn: scope => !scope.row.hasMock
        },
        {
          title: "未参加模考人数",
          type: "button",
          prop: "notMock",
          width: 150,
          align: "center",
          formatter: scope => String(scope.row.notMock || 0),
          click: row => this.goStudentList(row, "0"),
          disableFn: scope => !scope.row.notMock
        }
      ],
      tableOption: {},
      tableData: [],
      pagination: { total: 0 },

      // 短信督导
      sendDialog: false,
      groupLoading: false,
      content: '{学生姓名}您好，',
      tmpGroupCount: {
        shouldSendCount: 0,
        actualSendCount: 0,
        onlySendSmsCount: 0,
        onlySendEmailCount: 0,
        bothSendCount: 0
      }
    };
  },
  watch: {
    "requestForm.planId"() {
      this.onPlanChange();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      try {
        const { data } = await getPlanListApi();
        this.selectList[0].data = data || [];
        if (this.selectList[0].data.length > 0) {
          this.requestForm.planId = this.selectList[0].data[0].id;
        }
      } catch (e) {
        console.error("init studentMock error:", e);
      }
    },
    async onPlanChange() {
      if (!this.requestForm.planId) return;
      this.requestForm.courseIds = "";
      await this.loadCourseAndTable();
    },
    async loadCourseAndTable() {
      this.loading = true;
      try {
        const { data } = await studentMockGetCourseMockListApi({
          planId: this.requestForm.planId,
          courseIds: ""
        });
        this.tableData = data || [];
        this.pagination.total = this.tableData.length;
        this.selectList[1].data = [
          { courseName: "全部", courseId: "" },
          ...this.extractCourses(this.tableData)
        ];
      } finally {
        this.loading = false;
      }
    },
    async search() {
      if (!this.requestForm.planId) {
        this.$message.warning("请先选择考试批次");
        return;
      }
      this.loading = true;
      try {
        const { planId, courseIds } = this.requestForm;
        const { data } = await studentMockGetCourseMockListApi({ planId, courseIds });
        this.tableData = data || [];
        this.pagination.total = this.tableData.length;
      } finally {
        this.loading = false;
      }
    },
    extractCourses(list) {
      const map = new Map();
      list.forEach(item => {
        if (item.courseId && !map.has(item.courseId)) {
          map.set(item.courseId, { courseId: item.courseId, courseName: item.courseName });
        }
      });
      return Array.from(map.values());
    },
    goStudentList(row, mockStatus) {
      this.$router.push({
        name: "studentMockList",
        query: {
          planId: row.planId,
          courseId: row.courseId,
          courseName: row.courseName,
          mockName: row.mockName || "",
          mockStatus
        }
      });
    },
    formatTime(t) {
      if (!t) return "";
      if (Array.isArray(t)) {
        const [y, M, d, h = 0, m = 0, s = 0] = t;
        return `${y}-${String(M).padStart(2, "0")}-${String(d).padStart(2, "0")} ${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
      }
      return String(t).replace("T", " ");
    },
    openMessageDialog() {
      if (!this.requestForm.planId) {
        this.$message.warning("请先选择考试批次");
        return;
      }
      this.getGroupCount();
      this.sendDialog = true;
    },
    async getGroupCount() {
      this.groupLoading = true;
      this.tmpGroupCount = {
        shouldSendCount: 0,
        actualSendCount: 0,
        onlySendSmsCount: 0,
        onlySendEmailCount: 0,
        bothSendCount: 0
      };
      try {
        const params = {
          planId: this.requestForm.planId,
          courseIds: this.requestForm.courseIds
        };
        const { code, data } = await studentMockGetMessageSendGroupCountApi(params);
        if (code == 1) {
          this.tmpGroupCount = data || {};
        }
      } finally {
        this.groupLoading = false;
      }
    },
    messagePushFn() {
      if (!this.content) {
        this.$message.warning("请填写短信内容");
        return;
      }
      const params = {
        planId: this.requestForm.planId,
        courseIds: this.requestForm.courseIds,
        content: this.content
      };
      this.$confirm(
        `请再次确认是否发送${this.tmpGroupCount.actualSendCount || 0}条短信？`,
        "提示",
        { type: "warning" }
      )
        .then(() => {
          return studentMockSendMessageApi(params);
        })
        .then(({ code }) => {
          if (code == 1) {
            this.$message.success("发送成功。");
            this.content = "{学生姓名}您好，";
            this.sendDialog = false;
          }
        })
        .catch(() => {});
    }
  }
};
</script>


<style scoped lang="less">
#studentMock {
  padding: 0 20px;
}
</style>

<style>
.export-setting ul {
  margin-left: 5px;
}
.export-setting ul li {
  line-height: 26px;
}
</style>
